/* =========================================================================
   Finnish company-benefit labels
   Sources are official Vero decisions, Edenred/ePassi product pages,
   Kela, PAM and STM.  Updated: May 2025
   ====================================================================== */

/* ---------------- ENGLISH ------------------------------------------------ */
export const BENEFITS_EN: string[] = [
  /* https://www.smartum.fi/en/latest/tyosuhde-etujen-verorajat-vuonna-2025 */
  'Lunch benefit',

  /* https://benefits.workday.com/fi/sports-and-culture-vouchers */
  'Sports & culture benefit',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Massage benefit',

  /* https://www.epassi.fi/en/home */
  'Well-being / healthcare wallet',

  /* https://www.vero.fi/en/incomes-register/companies-and-organisations/employers/earnings-payment-data/fringe-benefits/bicycle-benefit-and-employer-subsidised-commuter-ticket/ */
  'Commuter pass',

  /* https://www.vero.fi/en/detailed-guidance/decisions/47380/in-kind-benefits-fringe-benefits-2025/ */
  'Company bike',

  /* https://stm.fi/en/occupational-health-care */
  'Occupational healthcare',

  /* https://www.vero.fi/en/individuals/tax-cards-and-tax-returns/income/earned-income/fringe-benefits-from-employment/ */
  'Extra health insurance',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Work phone',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Home-internet benefit',

  /* https://www.vero.fi/en/individuals/deductions/remote-working-and-deductions/ */
  'Remote-work allowance',

  /* https://stm.fi/en/working-hours-act */
  'Flexible working hours',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Training budget',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Cash bonus',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Stock options / RSU',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Extra pension',

  /* https://edenred.fi/en/employer/employee-benefit-taxation */
  'Accident / life insurance',

  /* https://www.pam.fi/en/working-life/guide-to-working-life/employment-relationships/wages-and-holiday-bonus/ */
  'Holiday bonus',

  /* https://www.kela.fi/private-day-care-allowance */
  'Child-care voucher',
];

/* ---------------- SWEDISH (Finland) ------------------------------------- */
export const BENEFITS_SV: string[] = [
  /* smartum.fi */ 'Lunchförmån',
  /* benefits.workday.com */ 'Motion- och kulturförmån',
  /* edenred.fi */ 'Massageförmån',
  /* epassi.fi */ 'Wellbeing-plånbok',
  /* vero.fi – commuter */ 'Arbetsresebiljett',
  /* vero.fi – bike */ 'Företagscykel',
  /* stm.fi */ 'Företagshälsovård',
  /* vero.fi – fringe */ 'Tilläggssjukförsäkring',
  /* edenred.fi */ 'Tjänstetelefon',
  /* edenred.fi */ 'Heminternet',
  /* vero.fi – remote */ 'Distansarbetsersättning',
  /* stm.fi – working hours */ 'Flexibla arbetstider',
  /* edenred.fi */ 'Utbildningsbudget',
  /* edenred.fi */ 'Kontantbonus',
  /* edenred.fi */ 'Aktieoptioner / RSU',
  /* edenred.fi */ 'Tilläggspension',
  /* edenred.fi */ 'Olycksfalls- / livförsäkring',
  /* pam.fi */ 'Semesterpenning',
  /* kela.fi */ 'Barnomsorgsförmån',
];

/* ---------------- FINNISH ------------------------------------------------ */
export const BENEFITS_FI: string[] = [
  /* smartum.fi */ 'Lounasetu',
  /* benefits.workday.com */ 'Liikunta- ja kulttuurietu',
  /* edenred.fi */ 'Hierontaetu',
  /* epassi.fi */ 'Hyvinvointietu',
  /* vero.fi – commuter */ 'Työsuhdematkalippu',
  /* vero.fi – bike */ 'Työsuhdepyörä',
  /* stm.fi */ 'Työterveyshuolto',
  /* vero.fi – fringe */ 'Lisäterveysvakuutus',
  /* edenred.fi */ 'Työpuhelin',
  /* edenred.fi */ 'Kotinetu',
  /* vero.fi – remote */ 'Etätyökorvaus',
  /* stm.fi – working hours */ 'Joustavat työajat',
  /* edenred.fi */ 'Koulutusbudjetti',
  /* edenred.fi */ 'Rahabonus',
  /* edenred.fi */ 'Osakeoptiot / RSU',
  /* edenred.fi */ 'Lisäeläke',
  /* edenred.fi */ 'Tapaturma- / henkivakuutus',
  /* pam.fi */ 'Lomaraha',
  /* kela.fi */ 'Lastenhoitoetu',
];
